import { CreateGroupSuccessCard } from '#src/pages/create/create_group_success_card/create_group_success_card.tsx';
import { useServices } from '#src/services/services.ts';
import { NotFoundPage } from '#src/ui/error/not_found_page.tsx';
import { PageLayout } from '#src/ui/layout/page_layout.tsx';
import { getGroupHref } from '#src/ui/navigation/navigation.ts';
import { useDocumentTitle } from '#src/ui/navigation/use_document_title.ts';
import { useLocation } from 'react-router';

const PAGE_TITLE = 'Your Secret Santa is Ready | draw.name';
const DEFAULT_PAGE_STATE = { groupId: undefined };

export const CreateSuccessPage = () => {
  useDocumentTitle(PAGE_TITLE);

  const { captureEvent } = useServices();
  const location = useLocation();
  const { groupId } = location.state ?? DEFAULT_PAGE_STATE;

  if (!groupId) {
    return <NotFoundPage />;
  }

  return (
    <PageLayout>
      <CreateGroupSuccessCard
        captureEvent={captureEvent}
        groupUrl={getGroupHref({ groupId, absolute: true })}
      />
    </PageLayout>
  );
};
